import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./Styles/index.css";

import * as Sentry from "@sentry/react";
import { buildSentryOptions } from "./Config/sentry";

Sentry.init(buildSentryOptions());

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
